import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";

interface ProtectionEditorCategoriesSummaryProps {
  categoriesCounter: number;
  messageId: string;
}

export const ProtectionEditorCategoriesSummary = ({
  categoriesCounter,
  messageId,
}: ProtectionEditorCategoriesSummaryProps) => {
  return (
    <Fragment>
      <div
        className="protection-editor-categories-summary"
        data-testid={`protection-editor-categories-summary-${messageId}`}
        aria-hidden={true}
      >
        <FormattedMessage id={messageId} />:
        <span className="protection-editor-categories-summary__counter">
          {categoriesCounter}
        </span>
      </div>
      <div className="sr-only">
        <FormattedMessage
          id={"aria_protection_editor_categories_summary"}
          values={{
            categoriesCounter: categoriesCounter,
            status: messageId,
          }}
        />
      </div>
    </Fragment>
  );
};
